import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { theme } from "./theme";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ScaleLoader from "react-spinners/ScaleLoader";

const appTheme = createMuiTheme(theme);

const Loader = () => (
  <div className="loader-outer">
    <div className="loader-middle">
      <div className="loader-inner">
        <ScaleLoader
          width={15}
          margin={"10px"}
          height={50}
          radius={5}
          color={theme.palette.primary[500]}
        />
      </div>
    </div>
  </div>
);

function AppWithTheme() {
  return (
    <Suspense fallback={<Loader />}>
    <MuiThemeProvider theme={appTheme}>
      <App />
    </MuiThemeProvider>
    </Suspense>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <AppWithTheme />
  </React.StrictMode>,
  document.getElementById('root')
);

